import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue"
import { useUtilities } from "@/hooks/useUtilities"
import Icon from "@/components/widgets/icons/Icon.vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'NavItem',
  props: {
  icon: {
    type: String,
    required: true,
  },

  name: {
    type: String,
    required: true,
  },

  temporary: {
    type: Boolean,
    default: false,
  },
  active: {
    type: Boolean,
    default: false,
  },
},
  emits: ["to"],
  setup(__props) {

const props = __props

const { collapseDrawer } = useUtilities()



const isDrawerCollapsed = () => {
  if (props.temporary) return false
  return collapseDrawer()
}



const iconColor = computed(() => {
  if (props.active) return "#FF8200"
  else return "#6C6C6C"
})

const textColor = computed(() => {
  if (props.active) return "#0B0101"
})

return { __sfc: true,collapseDrawer, isDrawerCollapsed, props, iconColor, textColor, Icon }
}

})